var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4417 1.33661C14.6275 0.816499 14.3564 0.244284 13.8363 0.0585306C13.3162 -0.127223 12.744 0.143826 12.5583 0.663936L7.55826 14.6639C7.3725 15.184 7.64355 15.7563 8.16366 15.942C8.68377 16.1278 9.25599 15.8567 9.44174 15.3366L14.4417 1.33661Z",
    fill: "#FEDE58"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83205 3.44557C8.1384 3.9051 8.01423 4.52597 7.5547 4.83232L2.80278 8.00027L7.5547 11.1682C8.01423 11.4746 8.1384 12.0954 7.83205 12.555C7.5257 13.0145 6.90483 13.1387 6.4453 12.8323L0.4453 8.83232C0.167101 8.64686 0 8.33463 0 8.00027C0 7.66592 0.167101 7.35369 0.4453 7.16822L6.4453 3.16822C6.90483 2.86187 7.5257 2.98604 7.83205 3.44557Z",
    fill: "#FEDE58"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1679 3.44557C13.8616 3.9051 13.9858 4.52597 14.4453 4.83232L19.1972 8.00027L14.4453 11.1682C13.9858 11.4746 13.8616 12.0954 14.1679 12.555C14.4743 13.0145 15.0952 13.1387 15.5547 12.8323L21.5547 8.83232C21.8329 8.64686 22 8.33463 22 8.00027C22 7.66592 21.8329 7.35369 21.5547 7.16822L15.5547 3.16822C15.0952 2.86187 14.4743 2.98604 14.1679 3.44557Z",
    fill: "#FEDE58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.131be938dd5e6a9dccb66fe958ecc9b6.svg";
export { ForwardRef as ReactComponent };